import { Helmet } from "react-helmet-async"
import { PGTransactions } from "../../../../Integrations"

export default function PGTransactionsPage() {
	return (
		<>
			<Helmet title="PG Transactions" />
			<PGTransactions />
		</>
	)
}
